<template>
    <div class="hiddenData">
        <van-cell-group style="margin-bottom: 10px;">
            <van-cell title="选择分类：" title-class="colorBlack" :value="tname">
            </van-cell>
            <van-field required label="楼栋号：" label-width="200" v-model="processForm.val1" input-align="right"
                placeholder="请输入楼栋号" />

            <van-field required type="textarea" label-width="200" label="影像资料描述:" v-model="processForm.val2"
                placeholder="请输入影像资料描述" rows="3" show-word-limit input-align="right" autosize />
            <van-field required label="文件:" style="align-items: center;" input-align="right">
                <template #input>
                    <van-uploader style="width:100%;max-height:200px;overflow-y: auto;" ref="upload"
                        v-model="processForm.fileList" multiple accept=".mp4,.jpg,.png" :after-read="afterRead" />
                </template>
            </van-field>
        </van-cell-group>
        <div style="width: 90%; margin: 20px auto;display: flex;">
            <van-button type="default" style="width: 40%; margin: auto" round @click="continueBtn()">取消</van-button>
            <van-button :loading="loading" type="info" style="width: 40%; margin: auto" round
                @click="onSubmit()">确认</van-button>
        </div>
    </div>
</template>
<script>
import {
    AddYwFilesWithTree
} from "@/api/index";
export default {

    name: "hiddenData",
    data() {
        return {
            questionInfo: {},
            tname: '',
            processForm: {
                val1: "",
                val2: "",
                val3: "",
                val4: "",
                val5: "",
                fileList: [],
            },
            upOrdelUser: [],
            replyUser: [],
            loading: false,
        }
    },
    methods: {
        afterRead(v, files) {
            // this.addfbForm.fileList = v;
        },
        continueBtn() {
            this.$router.push({
                path: "/home/menu/construction",
                query: { type: 0, title: '建设运维' },
            });
        },
        onSubmit() {
            if (this.processForm.val1 == '' || this.processForm.val2 === "" || this.processForm.fileList.length === 0) {
                this.$toast("请填写完整数据");
                return false;
            } else {
                this.loading = true;
                let fd = new FormData();
                this.processForm.fileList.forEach((file) => {
                    fd.append(`${file.file.name}^@^`, file.file);
                });
                fd.append("xid", this.$store.state.pid);
                fd.append("type", this.$route.query.type);
                fd.append("targetId", this.$route.query.feed.id);
                for (var key in this.processForm) {
                    fd.append(key, this.processForm[key]);
                }
                AddYwFilesWithTree(fd).then((res) => {
                    if (res.Code != 0) {
                        this.$Notify({ type: "success", message: "操作成功!" });
                        this.processForm = {
                            val1: "",
                            val2: "",
                            val3: "",
                            val4: "",
                            val5: "",
                            fileList: [],
                        };
                        this.$router.go(-1);
                    } else {
                        this.$Notify({ type: "danger", message: res.Message });
                    }
                    this.loading = false;
                });
            }
        }
    },
    mounted() {
        this.upOrdelUser = this.$route.query.upOrdelUser;
        this.replyUser = this.$route.query.replyUser;
        this.tname = this.$route.query.feed.tname;
        // this.getData()

    },
}
</script>
<style lang="scss" scoped>
.hiddenData {
    width: 100%;
    height: 100%;
    background: #fff;

    .colorBlack {
        // color: rgba(51, 51, 51, 1);
        color: #646566
    }
}
</style>
